import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';

export const getPaginatedCodigosData = async(options, idParceiro) => {
  if (idParceiro !== undefined && idParceiro !== null && idParceiro !== '') {
    const params = getParams(options);
    params.pagina = options.page;
    params.porPagina = 5;
    const httpClient = authenticatedHttpClientFactory();
    const response =
      await httpClient.get(`codigoParceiro/grid/${idParceiro}?${new URLSearchParams(params).toString()}`);
    return response.data;
  }
};

export const getAllCodigosData = async(options, idParceiro) => {
  const params = getParams(options);
  params.pagina = 1;
  params.porPagina = 1000000;
  const httpClient = authenticatedHttpClientFactory();
  const response =
  await httpClient.get(`codigoParceiro/export/${idParceiro}`);
  return response.data.map((data) => [
    `"${data.codigo}"`,
    `"${data.parceiro.nome}"`,
  ]);
};

const getParams = (options) => ({
  ordem: options.order,
  ordenarPor: options.sort,
  pesquisar: options.search,
});
